import React, { useMemo } from "react";

const StatisticsGrid = React.memo(({
  vocabularyList,
  statusFilter,
  setStatusFilter,
  getReviewPriority
}) => {
  // Memoize expensive statistics calculations to prevent repeated filtering
  const statistics = useMemo(() => {
    const total = vocabularyList.length;
    
    // Single pass through vocabulary list to calculate all stats
    const stats = vocabularyList.reduce((acc, word) => {
      const priority = getReviewPriority(word);
      
      switch (priority) {
        case "urgent":
          acc.urgent++;
          break;
        case "warning":
          acc.warning++;
          break;
        case "due":
          acc.due++;
          break;
        case "normal":
          acc.normal++;
          break;
      }
      
      return acc;
    }, { urgent: 0, warning: 0, due: 0, normal: 0 });

    return { total, ...stats };
  }, [vocabularyList, getReviewPriority]);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 mb-6">
      <button
        onClick={() => setStatusFilter("all")}
        className={`rounded-xl p-6 flex flex-col justify-center items-center text-center border transition-all duration-300 transform hover:scale-105 backdrop-blur-sm font-mono ${
          statusFilter === "all"
            ? "bg-black/80 border-cyan-400 shadow-neon-cyan text-cyan-100"
            : "bg-black/60 border-cyan-400/50 hover:border-cyan-400 text-cyan-300 hover:shadow-neon-cyan"
        }`}
      >
        <div className="text-2xl font-bold">{statistics.total}</div>
        <div className="text-xs uppercase tracking-wider">ALL UNITS</div>
      </button>

      <button
        onClick={() => setStatusFilter("urgent")}
        className={`rounded-xl p-6 flex flex-col justify-center items-center text-center border transition-all duration-300 transform hover:scale-105 backdrop-blur-sm font-mono ${
          statusFilter === "urgent"
            ? "bg-black/80 border-red-400 shadow-neon-pink text-red-100"
            : "bg-black/60 border-red-400/50 hover:border-red-400 text-red-300 hover:shadow-neon-pink"
        }`}
      >
        <div className="text-2xl font-bold">{statistics.urgent}</div>
        <div className="text-xs uppercase tracking-wider">CRITICAL</div>
      </button>

      <button
        onClick={() => setStatusFilter("warning")}
        className={`rounded-xl p-6 flex flex-col justify-center items-center text-center border transition-all duration-300 transform hover:scale-105 backdrop-blur-sm font-mono ${
          statusFilter === "warning"
            ? "bg-black/80 border-yellow-400 shadow-neon-green text-yellow-100"
            : "bg-black/60 border-yellow-400/50 hover:border-yellow-400 text-yellow-300 hover:shadow-neon-green"
        }`}
      >
        <div className="text-2xl font-bold">{statistics.warning}</div>
        <div className="text-xs uppercase tracking-wider">WARNING</div>
      </button>

      <button
        onClick={() => setStatusFilter("due")}
        className={`rounded-xl p-6 flex flex-col justify-center items-center text-center border transition-all duration-300 transform hover:scale-105 backdrop-blur-sm font-mono ${
          statusFilter === "due"
            ? "bg-black/80 border-blue-400 shadow-neon-cyan text-blue-100"
            : "bg-black/60 border-blue-400/50 hover:border-blue-400 text-blue-300 hover:shadow-neon-cyan"
        }`}
      >
        <div className="text-2xl font-bold">{statistics.due}</div>
        <div className="text-xs uppercase tracking-wider">PENDING</div>
      </button>

      <button
        onClick={() => setStatusFilter("normal")}
        className={`rounded-xl p-6 flex flex-col justify-center items-center text-center border transition-all duration-300 transform hover:scale-105 backdrop-blur-sm font-mono ${
          statusFilter === "normal"
            ? "bg-black/80 border-green-400 shadow-neon-green text-green-100"
            : "bg-black/60 border-green-400/50 hover:border-green-400 text-green-300 hover:shadow-neon-green"
        }`}
      >
        <div className="text-2xl font-bold">{statistics.normal}</div>
        <div className="text-xs uppercase tracking-wider">STABLE</div>
      </button>
    </div>
  );
});

export default StatisticsGrid; 